module.exports = __webpack_public_path__ + "static/think-54901a48dca2b86ac434516081829623.png";